module.exports = __webpack_public_path__ + "img/square.0e4e78cc.svg";